import styled from "styled-components";

const CommonWrapper = styled.div`
    height: 100%;
    min-height: calc(100vh - 70px);
    width: 100%;
    overflow-y: auto;

    &.loading-state {
        /* Voglio che sia absolute al body e non al div */
        position: fixed;
        top: 20px;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export default CommonWrapper;
